import script from "./BrandMark.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandMark.vue?vue&type=script&setup=true&lang=js"

import "./BrandMark.vue?vue&type=style&index=0&id=43eb3330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43eb3330"]])

export default __exports__